import { render, staticRenderFns } from "./class-list-page.html?vue&type=template&id=1bd78ba3&"
import script from "./class-list-page.ts?vue&type=script&lang=ts&"
export * from "./class-list-page.ts?vue&type=script&lang=ts&"
import style0 from "./class-list-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports